export default __webpack_public_path__ + "static/alawwal-nextImage-4ec8865cd0c35a39f6814b0fb63684d5.jpg";